import React from 'react';
import PropTypes from 'prop-types';
import AutosizeInput from 'react-input-autosize';

class FindErrorsEditor extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.specialCharRegex = new RegExp(`(${gon.specialCharRegex})`, 'mgi');
    this.state = {
      localStorageEnabled: this.localStorageEnabled(),
      inputValue: this.props.value,
      focusIndex: 0,
      initialValues: (this.props.initialValue || this.props.value).split(' ').flatMap(word => {
        return word.split(this.specialCharRegex);
      }).filter(Boolean),
      values: (() => {
        let index = 0;
        return this.props.value.split(' ').flatMap(word => {
          return word.split(this.specialCharRegex).map(part => {
            if (part.length) {
              index++;

              if (!this.localStorageEnabled()) return part;

              return window.localStorage.getItem(this.localStorageItemName(index)) || part;
            }
          });
        }).filter(Boolean)
      })(),
      correction: this.props.correction ? this.props.correction.split(' ').flatMap(word => {
        return word.split(this.specialCharRegex);
      }).filter(Boolean) : null
    };

    this.handleKeyBinding = this.handleKeyBinding.bind(this);
    this.localStorageEnabled = this.localStorageEnabled.bind(this);
    this.localStorageItemName = this.localStorageItemName.bind(this);
    this.saveContent = this.saveContent.bind(this);
    this.broadcastChange = this.broadcastChange.bind(this);
    this.getTextWidth = this.getTextWidth.bind(this);
    this.sortTexts = this.sortTexts.bind(this);
  }

  componentDidMount = () => {
    document.addEventListener("keydown", this.handleKeyBinding, false);

    setTimeout(() => {
      this.broadcastChange();
    }, 300);
  }

  componentWillUnmount = () => {
    document.removeEventListener("keydown", this.handleKeyBinding);
  }

  handleKeyBinding = event => {
    if (document.querySelector('.js-modal.block')) return;

    var keyCode = event.keyCode;
    if ((event.shiftKey && keyCode == 9) || keyCode == 117) { // Prev : Shift + Tab / F6
      this.focusPrevInput();
      event.stopPropagation();
      event.preventDefault();
    } else if (keyCode == 13 || keyCode == 9 || keyCode == 118) { // Next : Entrée / Tab / F7
      this.focusNextInput();
      event.stopPropagation();
      event.preventDefault();
    }
  }

  focusPrevInput() {
    this.setState(prevState => {
      prevState.focusIndex = prevState.focusIndex > 1 ? prevState.focusIndex - 1 : prevState.initialValues.length;
      return prevState;
    }, () => {
      const input = document.getElementById(`word-${this.state.focusIndex}`);
      if (input) {
        input.focus();
      } else {
        this.focusPrevInput();
      }
    });
  }

  focusNextInput() {
    this.setState(prevState => {
      prevState.focusIndex = prevState.focusIndex >= prevState.initialValues.length ? 1 : prevState.focusIndex + 1;
      return prevState;
    }, () => {
      const input = document.getElementById(`word-${this.state.focusIndex}`);
      if (input) {
        input.focus();
      } else {
        this.focusNextInput();
      }
    });
  }

  localStorageEnabled = () => {
    if (this.state && this.state.localStorageEnabled != undefined) return this.state.localStorageEnabled;

    var test = 'test';
    try {
      window.localStorage.setItem(test, test);
      window.localStorage.removeItem(test);
      return true;
    } catch(e) {
      return false;
    }
  }
  localStorageItemName = (input_index) => `dictation-${this.props.dictation_id}-${input_index}`;

  saveContent = (input_index, value) => {
    window.localStorage.setItem(this.localStorageItemName(input_index), value);
  }

  inputWord(string, index) {
    return (
      <span key={`key-input-word-${index}`} className={`h-8 relative border-b-2 ${this.state.focusIndex >= index ? 'border-success' : 'border-grey-mid'} text-white text-opacity-0 inline-block ${this.props.correction ? 'mb-24' : 'mb-12'} pointer-events-auto text-center`}>
        {
          (
            [
              this.props.correction ? this.state.correction[index-1] : this.state.values[index-1],
              this.state.initialValues[index-1],
              string
            ].filter(Boolean).sort(this.sortTexts)[0].replace(/ /g, "\u00a0")
          )
        }
        { this.props.correction ? (
          <span className={`absolute inset-0 mx-auto ${this.state.values[index-1] === this.state.correction[index-1] && this.state.values[index-1] === this.state.initialValues[index-1] ? 'text-white' : this.state.values[index-1] === this.state.correction[index-1] ? 'text-success' : 'text-danger bg-danger bg-opacity-25 line-through'}`}>{this.state.values[index-1] === this.state.initialValues[index-1] ? "" : this.state.values[index-1]}</span>
        ) : (
          <AutosizeInput
            id={`word-${index}`}
            className={`absolute inset-0 p-0 mx-auto ${this.state.values[index-1] === this.state.initialValues[index-1] ? "text-white" : "text-success"} input-value`}
            style={{ zIndex: this.state.values.length - index }}
            value={this.state.values[index-1]}
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck="false"
            onBlur={(event) => {
              const value = event.target.value.replace(' ', '').replace(' ', '');

              if (this.props.dictation_id && this.localStorageEnabled()) {
                this.saveContent(index, value);
              }

              this.setState(prevState => {
                prevState.values[index-1] = value.length ? value : prevState.initialValues[index-1];
                return prevState;
              }, () => {
                this.broadcastChange();
              });
            }}
            onFocus={(event) => {
              const inputId = parseInt(event.target.id.split('-')[1]);
              if (this.state.focusIndex != inputId) {
                this.setState({
                  focusIndex: inputId
                });
              }
            }}
            onChange={(event) => {
              const value = event.target.value.replace(' ', '').replace(' ', '');

              if (this.props.dictation_id && this.localStorageEnabled()) {
                this.saveContent(index, value);
              }

              this.setState(prevState => {
                prevState.values[index-1] = value;
                return prevState;
              }, () => {
                this.broadcastChange();
              });
            }}
          />
        ) }
      </span>
    )
  }

  broadcastChange () {
    PubSub.publish('DICTATION_COUNT_ERRORS', { initialValues: this.state.initialValues, values: this.state.values });
    this.setState(prevState => {
      prevState.inputValue = this.getInputValue();
      return prevState;
    })
  }

  getTextWidth(text, font) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    context.font = font || "20px / 30px Source Sans Pro, Helvetica, Arial, sans-serif";

    return context.measureText(text).width;
  }

  sortTexts(a,b) {
    return this.getTextWidth(b) - this.getTextWidth(a);
  }

  correctWord(string, index) {
    const display = this.state.values[index-1] !== this.state.correction[index-1];
    return (
      <span key={`key-input-word-${index}`} className={`h-8 relative text-white text-opacity-0 inline-block mb-24 pointer-events-auto text-center`}>
        {
          (
            [
              this.state.values[index-1],
              this.state.initialValues[index-1],
              string
            ].filter(Boolean).sort(this.sortTexts)[0].replace(/ /g, "\u00a0")
          )
        }
        <span className={`absolute inset-0 mx-auto ${display ? 'text-success bg-success bg-opacity-25' : 'text-white'} `}>{this.state.correction[index-1]}</span>
      </span>
    )
  }

  inputLabel(initial, value, index) {
    return (
      <span key={`key-input-label-${index}`} className={`h-8 relative text-white text-opacity-0 inline-block ${this.props.correction ? 'mb-24 unchanged' : 'mb-12 hover:bg-warning hover:bg-opacity-15 cursor-pointer' } pointer-events-auto`} data-word={this.props.correction ? this.state.correction[index-1] : undefined}>
        {
          (
            [
              this.props.correction ? this.state.correction[index-1] : value,
              value,
              initial,
            ].filter(Boolean).sort(this.sortTexts)[0].replace(/ /g, "\u00a0")
          )
        }
        <label htmlFor={`word-${index}`} className={`font-normal absolute inset-0 text-center cursor-pointer ${this.props.correction ? 'text-grey' : (value.length == 0 || value === initial) ? "text-black" : "text-danger"}`}>
          {initial}
        </label>
      </span>
    )
  }

  specialChar(string, index) {
    return (
      <span key={`key-special-char-${index}`} className="h-8 relative text-black inline-block mb-12 input-value">
        {string}
      </span>
    )
  }

  getInputValue() {
    const value = [];
    document.querySelectorAll('.c-text-editor-find-errors .input-value').forEach(word => {
      value.push(word.textContent);
    });

    return value.join('').trim();
  }

  render() {
    let index = 0;
    let label_index = 0;
    let correct_index = 0;

    return (
      <div className="dictation">
        { this.props.input_name && (<input type="hidden" name={this.props.input_name} value={this.state.inputValue} />) }
        <div className="c-text-editor-find-errors relative">
          { (this.props.initialValue || this.props.value).split(' ').map((word) => {
            const parts = word.split(this.specialCharRegex);
            return (
              <span key={`key-label-${label_index}`}>
                {
                  parts.map(part => {
                    if (part.length) {
                      label_index++;
                      return this.inputLabel(part, this.state.values[label_index-1], label_index);
                    }
                  })
                }
                <span> </span>
              </span>
            )
          }) }
          <div className="absolute top-0 mt-8 pointer-events-none">
            { this.props.value.split(' ').map((word) => {
              const parts = word.split(this.specialCharRegex);
              return (
                <span key={`key-input-${index}`}>
                  {
                    parts.map(part => {
                      if (part.length) {
                        index++;
                        if (part.match(this.specialCharRegex)) {
                          return this.specialChar(part, index);
                        } else {
                          return this.inputWord(part, index);
                        }
                      }
                    })
                  }
                  <span className="input-value"> </span>
                </span>
              )
            }) }
          </div>
          { this.props.correction && (
            <div className="absolute top-0 mt-16 pointer-events-none">
              { this.props.correction.split(' ').map((word) => {
                const parts = word.split(this.specialCharRegex);
                return (
                  <span key={`key-correction-${correct_index}`}>
                    {
                      parts.map(part => {
                        if (part.length) {
                          correct_index++;
                          return this.correctWord(part, correct_index);
                        }
                      })
                    }
                    <span className="input-value"> </span>
                  </span>
                )
              }) }
            </div>
          ) }
        </div>
      </div>
    );
  }
}

FindErrorsEditor.propTypes = {
  dictation_id: PropTypes.string,
  broadcastChange: PropTypes.bool,
  input_name: PropTypes.string,
  initialValue: PropTypes.string,
  correction: PropTypes.string,
  value: PropTypes.string,
  class: PropTypes.string,
  allowPaste: PropTypes.bool
};

FindErrorsEditor.defaultProps = {
  broadcastChange: true,
  class: "",
  allowPaste: false
};

export default FindErrorsEditor;
